import CSVPreviewSection from '../CSVPreviewSection'

export default function TTDetailCSVPreviewHeader() {}

TTDetailCSVPreviewHeader.prototype = new CSVPreviewSection();
TTDetailCSVPreviewHeader.prototype.constructor = TTDetailCSVPreviewHeader;

TTDetailCSVPreviewHeader.prototype.init = function( columnStrategy ){
    CSVPreviewSection.prototype.init.call(this);

    this.columnStrategy = columnStrategy;
    return this;
};
TTDetailCSVPreviewHeader.prototype.addRows = function( tBody ) {
    const firstHeaderRow = this.createRow("headerRow")
    this.columnStrategy.addFirstHeaderRowCells(firstHeaderRow);
    this.addRow(tBody, firstHeaderRow);
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/ttdetail/TTDetailCSVPreviewHeader.js